// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  OneHotExclusionGroup,
  OneHotExclusionGroupT,
  verifyOneHotExclusionGroup,
} from "./one-hot-exclusion-group";

/**
 * Top-level exclusion configuration for an adapter.
 * Stored in CDO as an optional field. When absent, no custom
 * exclusions are applied (existing hardcoded behavior unchanged).
 */
export class OneHotExclusionConfig implements flatbuffers.IUnpackableObject<OneHotExclusionConfigT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): OneHotExclusionConfig {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsOneHotExclusionConfig(
    bb: flatbuffers.ByteBuffer,
    obj?: OneHotExclusionConfig,
  ): OneHotExclusionConfig {
    return (obj || new OneHotExclusionConfig()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsOneHotExclusionConfig(
    bb: flatbuffers.ByteBuffer,
    obj?: OneHotExclusionConfig,
  ): OneHotExclusionConfig {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new OneHotExclusionConfig()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  groups(index: number, obj?: OneHotExclusionGroup): OneHotExclusionGroup | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new OneHotExclusionGroup()).__init(
          this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4),
          this.bb!,
        )
      : null;
  }

  groupsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  static startOneHotExclusionConfig(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addGroups(builder: flatbuffers.Builder, groupsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, groupsOffset, 0);
  }

  static createGroupsVector(
    builder: flatbuffers.Builder,
    data: flatbuffers.Offset[],
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!);
    }
    return builder.endVector();
  }

  static startGroupsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static endOneHotExclusionConfig(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createOneHotExclusionConfig(
    builder: flatbuffers.Builder,
    groupsOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    OneHotExclusionConfig.startOneHotExclusionConfig(builder);
    OneHotExclusionConfig.addGroups(builder, groupsOffset);
    return OneHotExclusionConfig.endOneHotExclusionConfig(builder);
  }

  unpack(): OneHotExclusionConfigT {
    return new OneHotExclusionConfigT(
      this.bb!.createObjList<OneHotExclusionGroup, OneHotExclusionGroupT>(
        this.groups.bind(this),
        this.groupsLength(),
      ),
    );
  }

  unpackTo(_o: OneHotExclusionConfigT): void {
    _o.groups = this.bb!.createObjList<OneHotExclusionGroup, OneHotExclusionGroupT>(
      this.groups.bind(this),
      this.groupsLength(),
    );
  }

  unpackFields(...fields: string[]): OneHotExclusionConfigT {
    const t = new OneHotExclusionConfigT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("groups")) {
      t.groups = this.bb!.createObjList<OneHotExclusionGroup, OneHotExclusionGroupT>(
        this.groups.bind(this),
        this.groupsLength(),
      );
    }
    return t;
  }
}

export class OneHotExclusionConfigT implements flatbuffers.IGeneratedObject {
  constructor(public groups: OneHotExclusionGroupT[] = []) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    const groups = OneHotExclusionConfig.createGroupsVector(
      builder,
      builder.createObjectOffsetList(this.groups),
    );

    return OneHotExclusionConfig.createOneHotExclusionConfig(builder, groups);
  }

  clone(): OneHotExclusionConfigT {
    const obj = new OneHotExclusionConfigT();
    obj.groups = this.groups.map((e) => e.clone());
    return obj;
  }

  equals(other: OneHotExclusionConfigT): boolean {
    if (this.groups.length !== other.groups.length) return false;
    for (let i = 0; i < this.groups.length; i++) {
      const a = this.groups[i];
      const b = other.groups[i];
      if (a !== null && b !== null) {
        if (!a.equals(b)) return false;
      } else if (a !== b) return false;
    }
    return true;
  }
}

export function verifyOneHotExclusionConfig(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkVectorOfTables(pos, verifyOneHotExclusionGroup);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
